import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

export default class DeleteWebemaillinkCommand extends Command {
  execute(options) {
    const editor = this.editor;
    const attributeLinkingTypes = CkeditorConstants.attributeLinkingTypes;
    const { linkText, linkAddress } = options;

    const isLinkOrSpan = (element) => {
      return element.name === CkeditorConstants.htmlElement.LINK_SPAN || element.name === CkeditorConstants.htmlElement.SPAN;
    };
    
    const isResourceLink = (element, linkAddress) => {
      return element.hasAttribute(CkeditorConstants.helperAttributes.RESOURCE) && element.getAttribute(CkeditorConstants.helperAttributes.RESOURCE) === linkAddress;
    };
    
    const isValidTypeOf = (element, linkingTypes) => {
      return element.hasAttribute(CkeditorConstants.helperAttributes.TYPE_OF) && linkingTypes.includes(element.getAttribute(CkeditorConstants.helperAttributes.TYPE_OF));
    };

    editor.model.change(writer => {
      const selection = editor.model.document.selection;
      const linkTextEvent = linkText;
      const linkAddressEvent = linkAddress;
      const arrText = Array.from(selection.getFirstPosition().parent.getChildren());
      let idxToRemove = arrText.findIndex((t) => t._data === linkTextEvent);
      idxToRemove = (idxToRemove >= 0) ? idxToRemove : 0;
      const plainText = arrText[idxToRemove].data;
      const elementSelected = arrText[idxToRemove].parent;

      if (!linkAddressEvent.includes("#")) {
        if (isLinkOrSpan(elementSelected) && isResourceLink(elementSelected, linkAddressEvent) && isValidTypeOf(elementSelected, attributeLinkingTypes)) {
          writer.remove(elementSelected);
        } else {
          const children = selection.getFirstPosition().parent.getChildren();
          for (let child of children) {
            if (child.hasAttribute('linkHref') && child._data === linkTextEvent) {
              this.editor.model.change(writer => {
                writer.remove(child);
              });
            }
          }
        }
        editor.model.insertContent(writer.createText(plainText), this.editor.model.document.selection);
      } else {
        if (isLinkOrSpan(elementSelected) && isResourceLink(elementSelected, linkAddressEvent) && isValidTypeOf(elementSelected, attributeLinkingTypes)) {
          writer.unwrap(elementSelected);
        }
      }
      
    })
  }
}
